/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
import { PageContainer, ProLayout } from '@ant-design/pro-components';
import { Suspense, useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import YQIcon from '@/renderer/components/common/YQIcon';
// import { useNavToLoginPageByRouteWhileUnlogin } from '@/hooks/useNavToLoginPageByRouteWhileUnlogin';
// import { useUserStore } from '@/renderer/store';
import { SmileFilled } from '@ant-design/icons';
import { Spin } from 'antd';
// import { useTranslation } from 'react-i18next';
import { useStoreInit } from '@/renderer/store';

const useMemuPathname = () => {
  const [pathname, setPathname] = useState('/');
  // 监听路由变化设置pathname
  const { pathname: locationPathname } = useLocation();
  useEffect(() => {
    setPathname(locationPathname);
  }, [locationPathname]);
  return pathname;
};

function Layout() {
  const pathname = useMemuPathname();
  const navigate = useNavigate();
  // useNavToLoginPageByRouteWhileUnlogin();
  // const { user: userInfo, onLogout } = useUserStore();
  // const { t } = useTranslation();
  useStoreInit();
  const route = useMemo(
    () => ({
      path: '/',
      routes: [
        {
          path: 'dashboard',
          name: 'dashboard',
          icon: <SmileFilled />,
        },
        // {
        //   path: '/account',
        //   name: '账号管理',
        //   icon: <CrownFilled />,
        // },
        // {
        //   path: '/position',
        //   name: '职位管理',
        //   icon: <CrownFilled />,
        // },
        // {
        //   path: '/resume',
        //   name: t('candidates'),
        //   icon: <SmileFilled />,
        // },
        // {
        //   path: '/knowledge',
        //   name: '知识库',
        //   icon: <CrownFilled />,
        // },
        // {
        //   path: '/question',
        //   name: '问题库',
        //   icon: <CrownFilled />,
        // },
      ],
    }),
    [],
  );
  return (
    <div
      id="test-pro-layout"
      style={{
        height: '100vh',
      }}
    >
      <ProLayout
        logo={
          <YQIcon
            src="https://oss.pop.public.hothappymax.com/yq_job/logo-icon-1.png"
            width={28}
            height={28}
          />
        }
        title="AI_Recruitment"
        token={{
          header: {
            colorBgHeader: '#292f33',
            colorHeaderTitle: '#fff',
            colorTextMenu: '#dfdfdf',
            colorTextMenuSecondary: '#dfdfdf',
            colorTextMenuSelected: '#fff',
            colorBgMenuItemSelected: '#22272b',
            colorTextMenuActive: 'rgba(255,255,255,0.85)',
            colorTextRightActionsItem: '#dfdfdf',
          },
          colorTextAppListIconHover: '#fff',
          colorTextAppListIcon: '#dfdfdf',
          sider: {
            colorMenuBackground: '#fff',
            colorMenuItemDivider: '#dfdfdf',
            colorBgMenuItemHover: '#f6f6f6',
            colorTextMenu: '#595959',
            colorTextMenuSelected: '#242424',
            colorTextMenuActive: '#242424',
          },
        }}
        siderWidth={216}
        route={route}
        location={{
          pathname,
        }}
        layout="mix"
        // TODO: 用户昵称和头像

        actionsRender={() => {
          return [
            // <InfoCircleFilled key="InfoCircleFilled" />,
            // <QuestionCircleFilled key="QuestionCircleFilled" />,
            // <GithubFilled key="GithubFilled" />,
            // <div key="setting">设置</div>,
          ];
        }}
        menuItemRender={(item, dom) => (
          <div
            onClick={() => {
              console.log('item', item);
              navigate(item.path || '/');
            }}
          >
            {dom}
          </div>
        )}
      >
        <PageContainer>
          <Suspense fallback={<Spin />}>
            <Outlet />
          </Suspense>
        </PageContainer>
      </ProLayout>
    </div>
  );
}

export default Layout;
